(() => {
  'use strict';
  if (window.cxShoppingHelp) return;
  window.cxShoppingHelp = true;
  const routes = new Set(['/pages/frame-finder', '/pages/virtual-try-on', '/pages/my-shelf', '/pages/find-your-lens']);
  const origin = location.origin;
  const contextKey = 'cx_retail_help_return_v1';
  const pairKey = 'cx_retail_help_pair_v1';
  const lifetime = 30 * 60 * 1000;
  let navigation = 0;
  let pairRevision = 0;
  const text = JSON.parse(document.getElementById('cx-help-text')?.textContent || '{}');
  const slug = /^[a-z0-9][a-z0-9-]{0,79}$/;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  const fresh = value => value && Number.isFinite(value.at) && value.at <= Date.now() && Date.now() - value.at < lifetime;
  function returnURL(value) {
    try {
      const u = new URL(value, origin);
      if (u.origin !== origin || !/^\/(?:products|collections)\/[a-z0-9-]+$/.test(u.pathname)) return null;
      const clean = new URL(u.pathname, origin);
      for (const [key, val] of u.searchParams) {
        if ((key === 'variant' && /^\d+$/.test(val)) || (/^filter\.[a-zA-Z0-9_.-]+$/.test(key) && val.length < 120) || (key === 'sort_by' && /^[a-z_-]+$/.test(val)) || (key === 'page' && /^\d{1,5}$/.test(val))) clean.searchParams.append(key, val);
      }
      return clean;
    } catch { return null; }
  }
  async function product(handle) {
    if (!slug.test(handle)) throw Error('invalid');
    const r = await fetch('/products/' + handle + '.js', { credentials: 'same-origin', cache: 'no-store', referrerPolicy: 'no-referrer' });
    if (!r.ok) throw Error('unavailable');
    const p = await r.json();
    if (p.handle !== handle || !Array.isArray(p.variants)) throw Error('invalid');
    return p;
  }
  function pairURL(value) {
    try {
      const u = new URL(value, origin);
      if (u.origin !== origin || u.pathname !== '/pages/my-shelf' || [...u.searchParams.keys()].some(k => !['choice1','choice2','favorite'].includes(k))) return null;
      const values = ['choice1','choice2'].map(k => u.searchParams.getAll(k));
      if (values.some(v => v.length !== 1 || !/^[a-z0-9-]+\.\d+$/.test(v[0])) || values[0][0] === values[1][0]) return null;
      const favorite = u.searchParams.getAll('favorite');
      if (favorite.length > 1 || favorite.length && !['1','2'].includes(favorite[0])) return null;
      return u;
    } catch { return null; }
  }
  async function availablePair(url) {
    return (await Promise.all(['choice1','choice2'].map(async key => {
      const [handle,id] = url.searchParams.get(key).split('.');
      const p = await product(handle);
      return p.available && p.variants.some(v => String(v.id) === id && v.available);
    }))).every(Boolean);
  }
  async function savePair(url) {
    const revision = ++pairRevision;
    const u = pairURL(url);
    if (!u) return;
    try { if (await availablePair(u) && revision === pairRevision) write(pairKey, {url:u.pathname+u.search, at:Date.now()}); } catch {}
  }
  function clearPair() { ++pairRevision; write(pairKey,null); }
  if (location.pathname === '/pages/my-shelf') {
    savePair(location.href);
    for (const id of ['cxms-share-url', 'cxms-favorite-url']) {
      const share = document.getElementById(id);
      if (share) new MutationObserver(() => { if (!share.hidden && share.getAttribute('href')) savePair(share.href); }).observe(share, {attributes:true, attributeFilter:['href','hidden']});
    }
    document.getElementById('cxms-share-clear')?.addEventListener('click', clearPair);
    document.getElementById('cxms-share-choices')?.addEventListener('change', clearPair);
    document.getElementById('cxms-share-choices')?.addEventListener('click', e => {
      const button = e.target.closest('button');
      // Existing My Shelf uses aria-pressed only for favorite controls.
      // A favorite preserves the pair; the response-link observer saves it.
      if (button && !button.hasAttribute('aria-pressed')) clearPair();
    });
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-cx-help-route]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const ticket = ++navigation;
    const detail = link.closest('[data-cx-help]');
    const status = detail.querySelector('[data-cx-help-status]');
    const back = returnURL(location.href);
    if (!back) return;
    const handle = detail.dataset.product;
    let label = '', variantId = null;
    if (handle) {
      const scope = detail.closest('[id^="MainProduct-"]') || detail.closest('section') || document;
      const input = scope.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
      const picker = scope.querySelector('variant-selects,variant-radios');
      const options = () => picker ? Array.from(picker.querySelectorAll('fieldset,select')).map(el => el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value) : [];
      if (picker && !input?.value || input?.disabled) { status.textContent=text.unknown; return; }
      variantId = input?.value || new URL(location.href).searchParams.get('variant');
      try {
        const p = await product(handle);
        const v = p.variants.find(v => String(v.id) === variantId);
        if (!variantId && p.variants.length === 1) variantId = String(p.variants[0].id);
        const selected = v || p.variants.find(v => String(v.id) === variantId);
        if (!selected) { status.textContent=text.unknown; return; }
        const visibleOptions = options();
        if (visibleOptions.length && (visibleOptions.length !== selected.options.length || visibleOptions.some((value,index) => value !== selected.options[index]))) { status.textContent=text.unknown;return; }
        if (!p.available || !selected.available) { status.textContent=text.unavailable; return; }
        if (input && input.value !== variantId) { status.textContent=text.unknown;return; }
        back.searchParams.set('variant', variantId);
        label = p.title + (selected.title === 'Default Title' ? '' : ' / ' + selected.title);
      } catch { status.textContent=text.unknown; return; }
    }
    let destination = new URL(link.getAttribute('href'), origin);
    if (destination.origin !== origin || !routes.has(destination.pathname)) return;
    if (link.dataset.cxHelpRoute === 'compare') {
      const saved = read(pairKey), pair = fresh(saved) && pairURL(saved.url);
      if (pair) {
        try {
          if (!await availablePair(pair)) { write(pairKey,null);status.textContent=text.pair_failed;return; }
          destination = pair;
        } catch { status.textContent=text.pair_failed;return; }
      }
    }
    if (ticket !== navigation) return;
    if (!write(contextKey, {url:back.pathname+back.search,label,handle,variantId,destination:destination.pathname,at:Date.now()})) {
      status.textContent=text.storage;
      return;
    }
    location.assign(destination.pathname+destination.search);
  });
  const bar = document.getElementById('cx-help-return');
  const saved = read(contextKey);
  if (bar && fresh(saved) && routes.has(saved.destination) && saved.destination === location.pathname) {
    const u = returnURL(saved.url);
    if (u) {
      const link = bar.querySelector('[data-cx-help-back]');
      link.href=u.pathname+u.search;link.textContent=text.back;
      const note=bar.querySelector('[data-cx-help-context]');
      note.textContent=(saved.label ? text.selection+' '+saved.label+'. ' : '')+text.select;
      if (saved.handle && saved.variantId) product(saved.handle).then(p => {
        if (!p.available || !p.variants.some(v => String(v.id) === saved.variantId && v.available)) note.textContent=text.unavailable;
      }).catch(() => { note.textContent=text.unknown; });
    }
  }
})();
